<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="年月:" class="item2">
          <el-date-picker
            v-model="searchFrom.salaryMonth"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="month"
          ></el-date-picker>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
            <el-button type="primary" @click="addFn" size="mini" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" @click="delFn" size="mini" v-if="btnFlg[3]">删除</el-button>
            <el-button type="primary" @click="importFn" size="mini" v-if="btnFlg[6]">导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown" v-if="btnFlg[7]">模板下载</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" style="width: 100%" height="100%" center border class="tableComent">
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="130" >
          <template slot-scope="scope">
            <div>
              <!-- <el-button type="text" size="mini" @click="pingzhengFn(scope.row)" v-if="btnFlg[4]">凭证</el-button> -->
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="btnFlg[5]">修改</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="salaryMonth" label="年月" min-width="100"></el-table-column>
        <el-table-column prop="workerName" label="机修工姓名" min-width="130"></el-table-column>
        <el-table-column prop="salary" label="实发工资(元)" min-width="120"></el-table-column>
        <el-table-column prop="insurance" label="保险费(元)" min-width="120"></el-table-column>
        <el-table-column prop="serviceFee" label="服务费(元)" min-width="120"></el-table-column>
        <el-table-column prop="canteenFee" label="食堂费(元)" min-width="120"></el-table-column>
        <el-table-column prop="dormFee" label="住宿费(元)" min-width="120"></el-table-column>
        <el-table-column prop="totalCost" label="合计费用(元)" min-width="120"></el-table-column>
        <el-table-column prop="hourlyRate" label="工时费(元/小时)" min-width="130"></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog :title="isAdd?'新增':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog" :visible.sync="addFlag" width="750px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan"  label-width="110px" size="mini" v-if="addFlag">
          <!-- <el-form-item label="小队:" prop="teamCode" class="width1" >
            <el-select v-model="addForm.teamCode" filterable placeholder="请选择" clearable @change="xiaoduiChange" >
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <br> -->
          <!-- <el-form-item label="司机姓名:" prop="driverId" class="width1" >
            <el-select v-model="addForm.driverId" filterable placeholder="请选择" @change="sijiChange">
              <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="司机电话:" prop="driverPhone" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.driverPhone" :readonly="true"></el-input>
          </el-form-item> -->
          <!-- <br> -->
          <!-- <el-form-item label="车头牌号:" prop="plateNumber" class="width1" >
            <el-select v-model="addForm.plateNumber" filterable placeholder="请选择" @change="carChange">
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="挂车牌号:" prop="trailerPlate" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.trailerPlate" :readonly="true"></el-input>
          </el-form-item> -->
          <el-form-item label="年月:" prop="salaryMonth">
            <el-date-picker
              v-model="addForm.salaryMonth"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="机修工姓名:" prop="workerName">
            <el-select v-model="addForm.workerName" filterable placeholder="请选择">
              <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="实发工资:" prop="salary" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="10" v-model="addForm.salary"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <el-form-item label="保险费:" prop="insurance" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="10" v-model="addForm.insurance"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <br>
          <el-form-item label="服务费:" prop="serviceFee" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="10" v-model="addForm.serviceFee"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <el-form-item label="食堂费:" prop="canteenFee" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="10" v-model="addForm.canteenFee"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <br>
           <el-form-item label="住宿费:" prop="dormFee" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="10" v-model="addForm.dormFee"></el-input>
            <span class="danwei" >元</span>
          </el-form-item>
          <br>
          <!-- <el-form-item label="凭证:" class="remark is-required" prop="remark" v-if="addFlag">
             <uploadImgs :imgList.sync='imgList' :max=3 @remove="remove"></uploadImgs>
          </el-form-item> -->
          <!-- <br> -->
          <!-- <el-form-item label="申请备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="addForm.remark"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 凭证 -->
    <el-dialog title="凭证" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="pzFlag" width="660px" center>
      <div class="fujianBox">
         <div class="imgBox">
            <el-image
              v-for="(item,index) in pzList" :src="item.fileKeyUrl" :key="index" :preview-src-list="getSrcList(index,pzList)">
            </el-image>
          </div>
      </div>
    </el-dialog>
    <el-image-viewer v-if="dialogImg" :on-close="closeViewer" :url-list="lookimgList" />
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { cRepairSalaryDetailList, cRepairSalaryDetailAdd, cRepairSalaryDetailupdate, cRepairSalaryDetaildelete, getOilCostDetail, cRepairSalaryDetailimport, getDictionaryDetailList } from '@/api/newTMS'
import { organizationTree, cDlists, cVIlists } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import importC from '@/components/import.vue'
export default {
  components: {
    uploadImgs, ElImageViewer, importC
  },
  props: {
    paramsFromParent: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        teamCode: [
          { required: true, message: '请选择小队', trigger: 'blur' }
        ],
        driverId: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        plateNumber: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        salaryMonth: [
          { required: true, message: '请选择年月', trigger: 'blur' }
        ],
        workerName: [
          { required: true, message: '请选择机修工姓名', trigger: 'blur' }
        ],
        salary: [
          { required: true, message: '请输入实发工资', trigger: 'blur' }
        ],
        insurance: [
          { required: true, message: '请输入保险费', trigger: 'blur' }
        ],
        serviceFee: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        canteenFee: [
          { required: true, message: '请输入食堂费', trigger: 'blur' }
        ],
        dormFee: [
          { required: true, message: '请输入住宿费', trigger: 'blur' }
        ]
      },
      isAdd: false,
      addFlag: false,
      addForm: { deleteAttachmentIds: [], expenseAll: [] },
      imgList: [],
      gysList: [], // 采购商
      XDList: [],
      sijiList: [],
      carList: [],
      pzList: [],
      pzFlag: false,
      dialogImg: false,
      lookimgList: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['01N02M0100', '01N02M0200', '01N02M0300', '01N02M0400', '01N02M0500', '01N02M0600', '01N02M0700', '01N02M0800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    if (!this.paramsFromParent) {
    // 没有 detailId 时，设置默认年月
      // this.searchFrom.month = this.getNextMonth()
      this.searchFn()
    }
    getDictionaryDetailList({ dictionaryType: 'repair_worker' }).then(res => { this.gysList = res })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 203) + 'px'
  },
  watch: {
    paramsFromParent: {
      handler (newVal) {
        if (newVal && newVal.salaryMonth) {
          // 重置分页
          this.searchFrom.pageNo = 1
          // 设置年月参数
          console.log(newVal.salaryMonth, 'newVal.salaryMonth')
          this.searchFrom.salaryMonth = newVal.salaryMonth
          // 清空其他可能的参数
          this.currentMasterId = null
          // 执行查询
          this.getList()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/机修工资导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ id: '' }))
      cRepairSalaryDetailimport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.msg = this.$message({
          showClose: true,
          message: res.message,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = { }
            exportExcel(
              this.global.tmsPlus + '/cRepairSalaryDetail/exportError',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data ? err.data : err.message
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data ? err.data : err.message,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 凭证
    pingzhengFn (row) {
      getOilCostDetail({ costId: row.id }).then(res => {
        if (res.attachments.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
        } else {
          this.lookimgList = []
          res.attachments.forEach((item, index) => {
            this.$set(this.lookimgList, index, item.fileKeyUrl)
          })

          this.dialogImg = true
        }
      })
    },
    closeViewer () {
      this.dialogImg = false
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.id == e)
        this.$set(this.addForm, 'driverName', json[0].name)
        this.$set(this.addForm, 'driverPhone', json[0].mobile)
        this.$set(this.addForm, 'idNumber', json[0].identityNo)
        this.$set(this.addForm, 'rootTissueId', json[0].companyOrgId)
        this.$set(this.addForm, 'rootTissueCode', json[0].companyOrgCode)
        this.$set(this.addForm, 'rootTissueName', json[0].companyOrgName)
      }
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.vhcNo == e)
        this.$set(this.addForm, 'vehicleId', json[0].id)
        this.$set(this.addForm, 'licensePlateColorName', json[0].noColourName)
        this.$set(this.addForm, 'vehicleTypeName', json[0].vhcTypeName)
        this.$set(this.addForm, 'trailerPlate', json[0].trailerNo)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamName', json[0].name)
        this.$set(this.addForm, 'teamId', json[0].id)
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.loading = false
          this.carList = res
        })
        this.$set(this.addForm, 'driverId', null)
        this.$set(this.addForm, 'driverName', null)
        this.$set(this.addForm, 'driverPhone', null)
        this.$set(this.addForm, 'idNumber', null)
        this.$set(this.addForm, 'rootTissueId', null)
        this.$set(this.addForm, 'rootTissueCode', null)
        this.$set(this.addForm, 'rootTissueName', null)
        this.$set(this.addForm, 'vehicleId', null)
        this.$set(this.addForm, 'plateNumber', null)
        this.$set(this.addForm, 'licensePlateColorName', null)
        this.$set(this.addForm, 'vehicleTypeName', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      this.$set(this.addForm, 'fillTime', new Date().getTime())
    },
    // 修改
    editFn  (row) {
      this.addForm = { ...row }
      this.addForm.deleteAttachmentIds = []
      this.imgList = []
      this.isAdd = false
      this.addFlag = true
      // cDlists({ driverClassify: 2, teamOrgId: row.teamOrgId }).then(res => {
      //   this.sijiList = res
      // })
      // cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: row.teamOrgId }).then(res => {
      //   this.loading = false
      //   this.carList = res
      // })
      // getOilCostDetail({ costId: row.id }).then(res => {
      //   this.isAdd = false
      //   this.addFlag = true
      //   res.attachments.forEach(item => {
      //     this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id })
      //   })
      // })
    },
    saveFn () {
      // if (this.imgList.length == 0) {
      //   this.$alert('请上传凭证', '系统提示')
      //   return
      // }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // let imgfile = new FormData()
          // this.imgList.forEach(item => {
          //   if (!item.id) {
          //     imgfile.append('files', item.raw)
          //   }
          // })

          // imgfile.set('params', JSON.stringify(this.addForm))
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            cRepairSalaryDetailAdd(this.addForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            cRepairSalaryDetailupdate(this.addForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.addForm.deleteAttachmentIds.push(file.id)
      }
    },
    // 供应商修改
    gysChange (e) {
      if (e) {
        this.$set(this.addForm, 'repairWorkers', this.addForm.expenseAll.toString())
      }
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].source == 1) {
        this.$alert('司机上报不可删除', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cRepairSalaryDetaildelete({
          id: selectData[0].id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/cRepairSalaryDetail/export',
        form,
        '机修工资明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      cRepairSalaryDetailList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.sum = res.map
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      // 重置时清空年月参数
      delete this.searchFrom.salaryMonth
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
        deleteAttachmentIds: []
      }
      this.imgLis = []
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
